<template>
  <div>
    <Top class="top" />
    <div class="l-container">
      <div class="inner">
        <div class="col_menu">
          <div class="col_menu_head">
            <h3 class="col_menu_text">党建之家</h3>
          </div>
          <div class="col_menu_con">
            <div class="col_list">
              <ul class="wp_listcolumn">
                <li :class="isActive===0?'select':''" @click="open()">
                  <a><span class="column-name">党务公开</span></a>
                </li>
                <li :class="isActive===1?'select':''" @click="inspect()">
                  <a><span class="column-name">纪检监察</span></a>
                </li>
                <li :class="isActive===2?'select':''" @click="history()">
                  <a><span class="column-name">学习教育</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col_news">
          <div class="col_news_box" v-if="isActive===0">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜党建之家 | 党务公开</span></span>
                </li>
                <li class="col_title">
                  <h2>党务公开</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div class="col_news_list">
                <ul>
                  <li v-for="(item,index) in listWord" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'党务公开'}}">{{item.articleTitle}}</router-link><span>{{item.releaseDate}}</span></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col_news_box" v-if="isActive===1">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜党建之家 | 纪检监察</span></span>
                </li>
                <li class="col_title">
                  <h2>纪检监察</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div class="col_news_list">
                <ul>
                  <li v-for="(item,index) in contactL" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'纪检监察'}}">{{item.articleTitle}}</router-link><span>{{item.releaseDate}}</span></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col_news_box" v-if="isActive===2">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜党建之家 | 学习教育</span></span>
                </li>
                <li class="col_title">
                  <h2>学习教育</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div class="col_news_list">
                <ul>
                  <li v-for="(item,index) in partyList" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'学习教育'}}">{{item.articleTitle}}</router-link><span>{{item.releaseDate}}</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterHtm style="margin-top: 10px"/>
  </div>
</template>

<script>
import $http  from '../ApI/request'  //$http是在导入时自定义的命名可变的
import Top from '../components/Top'
import FooterHtm from './FooterHtm'
export default {
  name: 'Party',
  components:{
    Top,
    FooterHtm
  },
  data(){
    let jd = localStorage.getItem('pajd');
    if (jd) {
      // console.log("1")
      if (this.$route.params.num) {
        localStorage.setItem('pajd', this.$route.params.num);
      }
    } else {
      // console.log("2")
      localStorage.setItem('pajd',this.$route.params.num)
    }
    return {
      listWord:[],
      contactL:[],
      partyList:[],
      isActive:0,
      num:localStorage.getItem('pajd'),
    }
  },
  mounted() {
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'党务公开',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.listWord = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'纪检监察',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.contactL = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'党史学习教育',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.partyList = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
  },
  methods:{
    jump(){
      this.$router.push({
        name:'HelloWorld',
      })
    },
    jumpS(){
      console.log(111)
      this.$router.push({
        name:'Survey',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('jdjd')
    },
    jumpT(){
      this.$router.push({
        name:'State',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('stjd')
    },
    jumpF(){
      this.$router.push({
        name:'Party',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('pajd')
    },
    jumpFI(){
      this.$router.push({
        name:'Culture',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('cujd')
    },
    jumpSI(){
      this.$router.push({
        name:'Relation',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('rejd')
    },
    open(){
      this.isActive = 0
    },
    inspect(){
      this.isActive = 1
    },
    history(){
      this.isActive = 2
    }
    // tabs(){
    //   trs[i].onmouseover = function() {
    //     this.className = "bg"
    //   }
    //   this.className = "second"
    // }
    // skip(){
    //   console.log(111)
    //   this.$router.push({
    //     name:'Party',
    //   })
    // }
  }
}
</script>

<style scoped>
.top{
  width: 100%;
}

.l-container {
  width: 100%;
  min-height: 760px;
  margin: 0 auto;
  background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
  padding: 40px 0;
}

.inner {
  padding: 0;
  width: 1300px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
}

.col_menu {
  width: 280px;
  flex-shrink: 0;
}

.col_menu_head {
  background: linear-gradient(to right, #0a3d82, #1e5dbd);
  border-radius: 8px 8px 0 0;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.2);
}

.col_menu_text {
  font-size: 24px;
  color: #fff;
  display: block;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  letter-spacing: 2px;
}

.col_list {
  background: white;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.1);
}

.wp_listcolumn {
  padding: 20px 0;
  margin: 0;
  list-style: none;
}

.wp_listcolumn li {
  margin: 0;
  padding: 0 20px;
}

.wp_listcolumn li a {
  padding: 15px 20px;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid rgba(12, 77, 162, 0.1);
  display: block;
  transition: all 0.3s ease;
  border-radius: 4px;
  cursor: pointer;
}

.wp_listcolumn li a:hover {
  background: rgba(12, 77, 162, 0.05);
  color: #0c4da2;
  transform: translateX(5px);
}

.wp_listcolumn li.select a {
  color: #0c4da2;
  background: rgba(12, 77, 162, 0.1);
  font-weight: bold;
}

.column-name {
  color: #333;
  font-size: 16px;
  transition: all 0.3s ease;
}

.wp_listcolumn li:hover .column-name {
  color: #1e5dbd;
}

.wp_listcolumn li.select .column-name {
  color: #1e5dbd;
  font-weight: bold;
}

.col_news {
  flex: 1;
  min-height: 500px;
}

.col_news_box {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.col_news_head {
  border-bottom: 1px solid rgba(12, 77, 162, 0.2);
  margin-bottom: 30px;
  padding-bottom: 15px;
}

.col_metas {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.col_path {
  color: #666;
  font-size: 14px;
}

.col_path span span {
  color: #0c4da2;
}

.col_title h2 {
  margin: 0;
  color: #0c4da2;
  font-size: 24px;
  font-weight: bold;
}

.col_news_con {
  padding: 20px 0;
}

.col_news_list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.col_news_list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid rgba(12, 77, 162, 0.1);
}

.col_news_list li a {
  flex: 1;
  color: #333;
  font-size: 16px;
  transition: all 0.3s ease;
  padding-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
}

.col_news_list li a:hover {
  color: #0c4da2;
  transform: translateX(5px);
}

.col_news_list li span {
  color: #999;
  font-size: 14px;
  flex-shrink: 0;
}

/* 响应式布局 */
@media screen and (max-width: 1400px) {
  .inner {
    width: 95%;
  }
}

@media screen and (max-width: 992px) {
  .inner {
    gap: 30px;
  }
  
  .col_menu {
    width: 250px;
  }
}

@media screen and (max-width: 768px) {
  .inner {
    flex-direction: column;
  }

  .col_menu {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .col_news {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Party.vue